import { GetVariants_trimLevelVariants_variants } from '../../gqlCommon/graphql/__generated__/GetVariants';
import { useCallback, useEffect, useMemo, useState, SyntheticEvent } from 'react';
import marketingCategoryService from '../../gqlCommon/service/marketingCategoryService';
import useUrlSearchParams from './useUrlSearchParams';

interface IUseMarketingCategoriesReturn {
  marketingCategories: string[];
  selectedMarketingCategory: string;
  setMarketingCategory: (e: SyntheticEvent<Element, Event>, category: string) => void;
}

const useMarketingCategories = (variants: GetVariants_trimLevelVariants_variants[]): IUseMarketingCategoriesReturn => {
  const [selectedMarketingCategory, setSelectedMarketingCategory] = useState(null);
  const { searchParams } = useUrlSearchParams();
  const variantId = searchParams?.variantId;

  const marketingCategories = useMemo(() => {
    if (variants.length) {
      return marketingCategoryService.getUniquerMarketingCategories(variants);
    }
    return [];
  }, [variantId, variants]);

  const setMarketingCategory = useCallback((e: SyntheticEvent, category: string) => {
    setSelectedMarketingCategory(category);
  }, []);

  useEffect(() => {
    const selectedVariant = variants?.find(
      (item: GetVariants_trimLevelVariants_variants) => item.variant.code === variantId,
    );
    const selectedMarketingCategory = selectedVariant?.variant?.attributes?.marketingCategory;
    setSelectedMarketingCategory(selectedMarketingCategory);
  }, [variants, variantId]);

  return { marketingCategories, setMarketingCategory, selectedMarketingCategory };
};

export default useMarketingCategories;
